<template>
  <div>
    <vue-good-table
        ref="superBomComponentWidthTable"
        class="mx-4"
        :columns="widthSuperBomComponentTableColumns"
        :rows="superBomComponents"
        :select-options="{
          enabled: false,
          selectAllByGroup: true,
        }"
        :line-numbers="true"
    >
      <div slot="emptystate">There are no entries</div>
      >

      <template slot="table-row" slot-scope="props">
        <span v-if="props.column.field == 'component_info'">
          {{ props.row.component_info }}
        </span>
        <span v-else-if="props.column.field == 'search_value'">
          <SearchValue v-bind:searchValue="props.row.search_value"></SearchValue>
        </span>
      </template>

      <div slot="selected-row-actions">
      </div>
    </vue-good-table>
  </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import 'vue-good-table/dist/vue-good-table.css'
import {VueGoodTable} from 'vue-good-table';
import SearchValue from "@/components/SuperBom/SearchValue";

export default {
  name: 'SuperBomComponentWidthList',
  components: {
    VueGoodTable,
    SearchValue,
  },
  computed: mapGetters(['allSuperBomComponents', 'superBomComponents', 'widthSuperBomComponentTableColumns']),
  methods: {
    ...mapActions(['fetchSuperBomComponents']),
  },
  async mounted() {
    // this.fetchSuperBomComponents(this.$route.params.superBomId);
  },
  data() {
    return {
      selected_count: 0,
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.superBom {
  border: 1px solid #ccc;
  border-radius: 5px;
  margin-bottom: 1rem;
}

small {
  display: block;
}
</style>